import { render, staticRenderFns } from "./ShowTestResultsGrid.vue?vue&type=template&id=590c868a&"
import script from "./ShowTestResultsGrid.vue?vue&type=script&lang=js&"
export * from "./ShowTestResultsGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports